export const Smile = () => {
	return (
		<span role="img" aria-label="Smile">
			🙂
		</span>
	);
};
